export const parseImpressionTrackingData = (data) => {
    if (typeof data !== "string") return data;
    try {
        return JSON.parse(data);
    } catch (e) {
        return null;
    }
};
